<template>
  <div class="account-page">
    <div class="main-wrapper">
      <div class="account-content">
        <div class="login-wrapper">
          <div class="login-img">
            <img src="../../../assets/img/login.png" alt="img" />
          </div>
          <div class="login-content">
            <div class="login-userset">
              <div class="login-logo logo-normal">
                <img src="../../../assets/img/logo.png" alt="img" />
              </div>
              <router-link to="/index" class="login-logo logo-white">
                <img src="../../../assets/img/logo-white.png" alt="" />
              </router-link>
              <div class="login-userheading">
                <h3>Confirmation PIN</h3>
                <h4>Please enter your new pin again</h4>
              </div>
              <form class="login" @submit.prevent="onSubmit">
                <div class="form-login">
                  <label>Pin</label>
                  <div class="form-addons">
                    <div class="d-flex gap-2">
                      <div v-for="(field, index) in pinFields" :key="index">
                        <input
                          v-model="pinFields[index]"
                          @input="handleInput(index)"
                          @keydown="handleKeyDown(index, $event)"
                          :maxlength="1"
                          :autofocus="index === 0"
                          type="text"
                          :ref="'pinField' + index"
                          ref-in-for
                          :id="'pin' + (index + 1)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-login">
                  <button class="btn btn-login" type="submit" ref="buttonSignin">Save</button>
                </div>
              </form>
              <div class="signinform text-center d-flex justify-content-between">
                <router-link to="/" class="hover-a">Change account</router-link>
                <h4>Make new one again? <router-link to="/reset-pin" class="hover-a">Reset PIN</router-link></h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
import { AlertPopup2, base_url, timeout, ErrorConnectionTimeOut, goPage } from "@/assets/js/function";

export default {
  data() {
    return {
      pinFields: ['', '', '', '']
    };
  },
  methods: {
    handleInput(index) {
      this.pinFields[index] = this.pinFields[index].replace(/[^0-9]/g, '');
      if (this.pinFields[index].length === 1 && index < 3) {
        const next = this.$refs['pinField' + (index + 1)];
        if (next && next[0]) next[0].focus();
      }
      if (index === 3) {
        this.onSubmit();
      }
    },
    handleKeyDown(index, event) {
      if (event.key.match(/[^0-9]/) && event.key !== 'Backspace') {
        event.preventDefault();
      } else if (event.key === 'Backspace' && index > 0 && this.pinFields[index] === '') {
        const prev = this.$refs['pinField' + (index - 1)];
        if (prev && prev[0]) prev[0].focus();
      }
    },
    async onSubmit() {
      try {
        const pinFinal = this.pinFields.join('');
        const formData = new FormData();
        formData.append("pin", pinFinal);
        formData.append("pin_konfirmasi", localStorage.getItem('pin-confirm'));
        formData.append("phone", localStorage.getItem('phone'));
        formData.append("token_refresh", Cookies.get('token_refresh'));

        const api = base_url + 'v3/auth/confirm';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;

        if (data.status) {
          Cookies.set("token_refresh", data.data.token);
          localStorage.removeItem('pin-confirm');
          localStorage.removeItem('SendOTPDate');
          localStorage.removeItem('isSendOTP');
          localStorage.removeItem('phone');
          localStorage.removeItem('tipe_login');
          goPage('index');
        } else {
          this.pinFields = ['', '', '', ''];
          setTimeout(() => document.getElementById("pin1").focus(), 1800);
          AlertPopup2("error", "", data.message, true, 2000);
        }

      } catch (err) {
        ErrorConnectionTimeOut(err);
      }
    }
  },
  created() {
    if (!Cookies.get('token_refresh')) {
      goPage('/');
    }
  }
};
</script>
